import { CurecallCopyButton, CurecallTooltip, ECurecallSize } from '@honestica/curecall-ui'
import { TPatient } from 'src/types/patient'
import { useTranslation } from 'react-i18next'
import { getFormattedDate } from 'src/utils/date-formatter.util'
import { PatientPhone } from 'src/components/patient/patient-phone.component'
import { useSession } from 'src/providers/auth.provider'
import { AdminOnlyBadge } from 'src/components/admin-only-badge.component'
import { useCurrentProject } from 'src/providers/current-project.provider'
import { LifenPatientRefItem } from './lifen-patient-search/lifen-patient-ref-item.component'

export type Props = {
  patient: TPatient
  onOverrideChannel?: () => void
}

const PatientDetailsList = ({ patient, onOverrideChannel }: Props) => {
  const { t } = useTranslation()
  const { currentUser } = useSession()
  const { project } = useCurrentProject()

  const liStyle =
    'last-of-type:c-border-none c-flex c-font-medium c-text-sm  c-flex-row c-items-center c-border-r-2 c-border-grey-200 c-pr-4 c-pl-4 first-of-type:c-pl-0'

  return (
    <ul className="c-flex c-flex-wrap">
      {(!patient.remoteId || currentUser?.isAdmin) && (
        <li className={liStyle}>
          <CurecallTooltip
            tooltipPosition="bottom-start"
            content={`${t('common.actions.copy')} : ${t('common.patient.id')}`}
          >
            <CurecallCopyButton
              ariaLabelText={t('common.patient.id')}
              data={patient.id}
              size={ECurecallSize.MEDIUM}
              className="tw-w-max tw-mr-2 tw-h-8"
            />
          </CurecallTooltip>
          <span>{`${t('common.patient.id')} : ${patient.id}`}</span>
          {currentUser?.isAdmin && patient.remoteId && <AdminOnlyBadge />}
        </li>
      )}

      {patient.remoteId && (
        <li className={liStyle}>
          <CurecallTooltip
            tooltipPosition="bottom-start"
            content={`${t('common.actions.copy')} : ${t('common.patient.remoteId')}`}
          >
            <CurecallCopyButton
              ariaLabelText={t('common.patient.remoteId')}
              data={patient.remoteId}
              size={ECurecallSize.MEDIUM}
              className="tw-w-max tw-mr-2  tw-h-8"
            />
          </CurecallTooltip>
          <span>{`${t('common.patient.remoteId')} : ${patient.remoteId}`}</span>
        </li>
      )}

      {currentUser?.isAdmin && project.lifenWorkplaceRef && (patient.lifenPatientRef || patient.remoteId) && (
        <li className={liStyle}>
          <LifenPatientRefItem patient={patient} projectId={project.id} />
          <AdminOnlyBadge className="c-ml-2" />
        </li>
      )}

      <li className={liStyle}>
        <PatientPhone
          patient={patient}
          showCopyButton={true}
          showCommunicationChannelIcon={true}
          onOverrideChannel={currentUser?.isAdmin ? onOverrideChannel : undefined}
        />
      </li>

      {patient.MedicalStaffMember && (
        <li className={liStyle}>
          {patient.MedicalStaffMember.civility} {patient.MedicalStaffMember.firstname}{' '}
          {patient.MedicalStaffMember.lastname}
        </li>
      )}

      {patient.birthdate && <li className={liStyle}>{getFormattedDate(patient.birthdate)}</li>}
    </ul>
  )
}

export default PatientDetailsList
